import React from "react";
import ChitPosting from "./ChitPosting";

const Authorizations = () => {
  return (
    <div className="h-100 d-flex flex-column">
      <ChitPosting authorizationOnly />
    </div>
  );
};

export default Authorizations;
